import React from "react";
import styles from './requestDetailsMobile.module.css';
import { useState } from 'react';
import { Archive, ArrowUp, ChevronDown, ChevronLeft, Edit, MoreVertical, Trash2 } from "react-feather";
import ResolutionMobile from "./mobileComponent/resolutionMobile";
import RequestMobile from "./mobileComponent/requestMobile";
import CommentMobile from "./mobileComponent/commentMobile";
import HistoryMobile from "./mobileComponent/historyMobile";
import FeedbackMobile from "./mobileComponent/feedbackMobile";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import dayjs from "dayjs";

const OpenedToggleReadOnly = React.forwardRef(({ children, onClick }, ref) => (
  <button ref={ref} className={`${styles.ReferStatusBU} ${styles.ReferStatusBUNew} ${styles.Open}`} onClick={(e) => { e.preventDefault(); onClick(e); }}>
    Open
  </button>
));

const ResolvedToggleReadOnly = React.forwardRef(({ children, onClick }, ref) => (
  <button ref={ref} className={`${styles.ReferStatusBU} ${styles.ReferStatusBUNew} ${styles.Resolved}`} onClick={(e) => { e.preventDefault(); onClick(e); }}>
    Resolved
  </button>
));

const AssignedToggleReadOnly = React.forwardRef(({ children, onClick }, ref) => (
  <button ref={ref} className={`${styles.ReferStatusBU} ${styles.ReferStatusBUNew} ${styles.InProgress}`} onClick={(e) => { e.preventDefault(); onClick(e); }}>
    Assigned
  </button>
));

const ScheduledToggleReadOnly = React.forwardRef(({ children, onClick }, ref) => (
  <button ref={ref} className={`${styles.ReferStatusBU} ${styles.ReferStatusBUNew} ${styles.Scheduled}`} onClick={(e) => { e.preventDefault(); onClick(e); }}>
    Scheduled
  </button>
));

const CancelledToggleReadOnly = React.forwardRef(({ children, onClick }, ref) => (
  <button ref={ref} className={`${styles.ReferStatusBU} ${styles.ReferStatusBUNew} ${styles.Cancelled}`} onClick={(e) => { e.preventDefault(); onClick(e); }}>
    Cancelled
  </button>
));

const OpenedToggle = React.forwardRef(({ children, onClick }, ref) => (
  <button ref={ref} className={`${styles.ReferStatusBU} ${styles.Open}`} onClick={(e) => { e.preventDefault(); onClick(e); }}>
    Open <ChevronDown className={`${styles.DownArrowStatus}`} />
  </button>
));

const ResolvedToggle = React.forwardRef(({ children, onClick }, ref) => (
  <button ref={ref} className={`${styles.ReferStatusBU} ${styles.Resolved}`} onClick={(e) => { e.preventDefault(); onClick(e); }}>
    Resolved <ChevronDown className={`${styles.DownArrowStatus}`} />
  </button>
));

const AssignedToggle = React.forwardRef(({ children, onClick }, ref) => (
  <button ref={ref} className={`${styles.ReferStatusBU} ${styles.InProgress}`} onClick={(e) => { e.preventDefault(); onClick(e); }}>
    Assigned <ChevronDown className={`${styles.DownArrowStatus}`} />
  </button>
));

const ScheduledToggle = React.forwardRef(({ children, onClick }, ref) => (
  <button ref={ref} className={`${styles.ReferStatusBU} ${styles.Scheduled}`} onClick={(e) => { e.preventDefault(); onClick(e); }}>
    Scheduled <ChevronDown className={`${styles.DownArrowStatus}`} />
  </button>
));

const CancelledToggle = React.forwardRef(({ children, onClick }, ref) => (
  <button ref={ref} className={`${styles.ReferStatusBU} ${styles.Cancelled}`} onClick={(e) => { e.preventDefault(); onClick(e); }}>
    Cancelled <ChevronDown className={`${styles.DownArrowStatus}`} />
  </button>
));

const RequestDetails = ({ requestData, setRequestData, setLoading, appointments, labors, materials, contractors, vehicles, notes, histories, feedbacks, setSnackbarOpen, setSnackbarMsg, changeStatus, setEditModalOpen, setArchiveModalOpen, setDelModalOpen }) => {
  const [active, setActive] = useState(null);
  const { user, isAuthenticated } = useAuth0();
  const [requestImage, setRequestImage] = useState('/static/img/other.svg');

  useEffect(() => {
    if (requestData) {
      if (requestData?.sub_category === 'Electrical Socket') {
        setRequestImage("/static/img/ElectricalSocket.svg");
      } else if (requestData?.sub_category === 'Light Switch/Dimmer') {
        setRequestImage("/static/img/Dimmer.svg");
      } else if (requestData?.sub_category === 'Mount Television') {
        setRequestImage("/static/img/tv.svg");
      } else if (requestData?.sub_category === 'Leak') {
        setRequestImage("/static/img/Leak.svg");
      } else if (requestData?.sub_category === 'Drain Clogged') {
        setRequestImage("/static/img/DrainClogged.svg");
      } else if (requestData?.sub_category === 'Water Temperature Issue') {
        setRequestImage("/static/img/WaterTemperature.svg");
      } else if (requestData?.sub_category === 'Heating & Cooling System') {
        setRequestImage("/static/img/heat&cool.svg");
      } else if (requestData?.sub_category === 'Stove/Oven Issue') {
        setRequestImage("/static/img/StoveOven.svg");
      } else if (requestData?.sub_category === 'Refrigerator Issue') {
        setRequestImage("/static/img/Refrigerator.svg");
      } else if (requestData?.sub_category === 'Washer/Dryer Issue') {
        setRequestImage("/static/img/Washer.svg");
      } else if (requestData?.sub_category === 'Other Issue') {
        setRequestImage("/static/img/other.svg");
      }

      if (!active) {
        if (requestData?.current_status === 3) {
          setActive("one");
        } else {
          setActive("two");
        }
      }
    }
  }, [requestData]);

  const toggle = (name) => {
    setActive((prev) => (prev === name ? null : name));
  }

  return (<>
    <div className={`${styles.UserMainDiv}`}>
      <Link className={`${styles.BackAddBU}`} to={"/cases/maintenance-request"}><ChevronLeft /></Link>

      {(isAuthenticated && (user["https://propertydek.com/permissions"].indexOf("request:update") > -1 || user["https://propertydek.com/permissions"].indexOf("request:delete") > -1)) && (<Dropdown className={`${styles.ProEditSec}`}>
        <Dropdown.Toggle className={`${styles.EditActionsBU} ProsDrBU`} id="dropdown-basic">
          <MoreVertical />
        </Dropdown.Toggle>

        <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
          {(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("request:update") > -1) && <>
            <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => setEditModalOpen(true)}>
              <Edit /> Edit
            </Dropdown.Item>
            <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => setArchiveModalOpen(true)}>
              <Archive /> {requestData?.is_archived ? "Unarchive" : "Archive"}
            </Dropdown.Item>
          </>}
          {(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("request:delete") > -1) && <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => setDelModalOpen(true)}>
            <Trash2 /> Delete
          </Dropdown.Item>}
        </Dropdown.Menu>
      </Dropdown>)}

      <div className={`${styles.DetailTopSec}`}>
        <div className={`${styles.DetailTopImgSec}`}>
          <img src={requestImage} class={`${styles.IMG}`} alt="" />
        </div>
        <div className={`${styles.DetailTopConSec}`}>
          <p className={`${styles.Title}`}>{requestData?.title}</p>
          <div className={`${styles.MainReCardIdStatus}`}>
            <p className={`${styles.MainReID}`}><Link to={"/people/tenants/details/" + requestData?.tenant_id}>{requestData?.tenant_name}</Link></p>
            <div className={`${styles.MainReqConDropBU}`}>
              {(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("request:update")) > -1 ? (<Dropdown>
                {requestData?.current_status === 0 && (<Dropdown.Toggle as={OpenedToggle} />)}
                {requestData?.current_status === 1 && (<Dropdown.Toggle as={AssignedToggle} />)}
                {requestData?.current_status === 2 && (<Dropdown.Toggle as={ScheduledToggle} />)}
                {requestData?.current_status === 3 && (<Dropdown.Toggle as={ResolvedToggle} />)}
                {requestData?.current_status === 4 && (<Dropdown.Toggle as={CancelledToggle} />)}

                <Dropdown.Menu className="DropDownMenuBoxCus">
                  <Dropdown.Item className="DropDListWIcon" onClick={(e) => { e.stopPropagation(); changeStatus(0); }}>Open</Dropdown.Item>
                  <Dropdown.Item className="DropDListWIcon" onClick={(e) => { e.stopPropagation(); changeStatus(1); }}>Assigned</Dropdown.Item>
                  <Dropdown.Item className="DropDListWIcon" onClick={(e) => { e.stopPropagation(); changeStatus(2); }}>Scheduled</Dropdown.Item>
                  <Dropdown.Item className="DropDListWIcon" onClick={(e) => { e.stopPropagation(); changeStatus(3); }}>Resolved</Dropdown.Item>
                  <Dropdown.Item className="DropDListWIcon" onClick={(e) => { e.stopPropagation(); changeStatus(4); }}>Cancelled</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>) : (<>
                {requestData?.current_status === 0 && (<Dropdown.Toggle as={OpenedToggleReadOnly} />)}
                {requestData?.current_status === 1 && (<Dropdown.Toggle as={AssignedToggleReadOnly} />)}
                {requestData?.current_status === 2 && (<Dropdown.Toggle as={ScheduledToggleReadOnly} />)}
                {requestData?.current_status === 3 && (<Dropdown.Toggle as={ResolvedToggleReadOnly} />)}
                {requestData?.current_status === 4 && (<Dropdown.Toggle as={CancelledToggleReadOnly} />)}
              </>)}
            </div>
          </div>
          <div className={`${styles.MainReCardIdStatus}`}>
            <p className={`${styles.MainReID}`}>{requestData?.property_name} <span>{requestData?.apt_name}</span> <span>{requestData?.request_no}</span></p>
          </div>
          <div className={`${styles.MainReCardIdStatusTwo}`}>
            <p className={`${styles.MainReDate}`}>Submitted {dayjs(requestData?.created_at).fromNow()}</p>
            {requestData?.priority === 1 && <p className={`${styles.ReffStatus} ${styles.Low}`}><ArrowUp /> <span>Low</span></p>}
            {requestData?.priority === 2 && <p className={`${styles.ReffStatus} ${styles.Medium}`}><ArrowUp /> <span>Medium</span></p>}
            {requestData?.priority === 3 && <p className={`${styles.ReffStatus} ${styles.High}`}><ArrowUp /> <span>High</span></p>}
          </div>
        </div>
      </div>
      <div className={styles.AccordionSecMain}>

        <ResolutionMobile
          isPanelOpen={active === "one"}
          onToggle={() => toggle("one")}
          requestData={requestData}
          setRequestData={setRequestData.bind(this)}
          setLoading={setLoading.bind(this)}
        />

        <RequestMobile
          isPanelOpen={active === "two"}
          onToggle={() => toggle("two")}
          requestData={requestData}
          setRequestData={setRequestData.bind(this)}
          setLoading={setLoading.bind(this)}
        />

        {/* {(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("request-workorder:show")) > -1 && <WorkOrderMobile
          isPanelOpen={active === "three"}
          onToggle={() => toggle("three")}
          requestData={requestData}
          appointments={appointments}
          setRequestData={setRequestData.bind(this)}
          setSnackbarOpen={setSnackbarOpen.bind(this)}
          setSnackbarMsg={setSnackbarMsg.bind(this)}
          setLoading={setLoading.bind(this)}
          contractors={contractors}
          labors={labors}
          materials={materials}
          vehicles={vehicles}
        />} */}

        {(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("request-note:show")) > -1 && <CommentMobile
          isPanelOpen={active === "four"}
          onToggle={() => toggle("four")}
          notes={notes}
          requestData={requestData}
          setRequestData={setRequestData.bind(this)}
          setSnackbarOpen={setSnackbarOpen.bind(this)}
          setSnackbarMsg={setSnackbarMsg.bind(this)}
          setLoading={setLoading.bind(this)}
        />}

        {(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("request-history:show")) > -1 && <HistoryMobile
          isPanelOpen={active === "five"}
          onToggle={() => toggle("five")}
          histories={histories}
          requestData={requestData}
        />}

        {(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("request-feedback:show")) > -1 && <FeedbackMobile
          isPanelOpen={active === "six"}
          onToggle={() => toggle("six")}
          feedbacks={feedbacks}
        />}

      </div>
    </div >
  </>)
}

export default RequestDetails;